import type { StorageDashboardSummary } from './storageDashboardTypes';
import { DashboardCardLinkButton } from './DashboardCardLinkButton';

interface StorageAccessCardProps {
  summary: StorageDashboardSummary;
  title?: string;
  subtitle?: string;
  openHref: string;
  openLabel: string;
}

export function StorageAccessCard({
  summary,
  title = 'Your Storage',
  subtitle = 'Mounts you can access on this site',
  openHref,
  openLabel
}: StorageAccessCardProps) {
  return (
    <section className="dashboard-card dashboard-card--storage">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">{title}</h3>
          <p>{subtitle}</p>
        </div>
        <DashboardCardLinkButton text={openLabel} href={openHref} />
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.mounts.length}</span>
          <span className="dashboard-kpi__label">Accessible mounts</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.writableMountCount}</span>
          <span className="dashboard-kpi__label">Writable mounts</span>
        </div>
      </div>

      <div className="dashboard-card__section">
        <h4 className="dashboard-card__section-title">Mounts</h4>
        {summary.mounts.length === 0 ? (
          <p className="dashboard-empty">No storage mounts are available for your account yet.</p>
        ) : (
          <div className="dashboard-type-row" aria-label="Accessible mounts">
            {summary.mounts.map((mount) => (
              <span key={mount.id} className="dashboard-pill">
                {mount.displayName}: {mount.accessMode}
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
